/* eslint-disable*/
import { name } from "./__init__";
import { createSelector } from "reselect";
import { convertRawARIDataToToCalendarFormat } from "./util"; // eslint-disable-line
import { getCalendarKey } from "./util";
import { dateDiffInDays } from "../../utils/date";
//import {selectors as appSelectors} from '../../containers/App';
import {
  currencyExchangeSelector,
  currencySelector,
  numberOfGuestsSelector as appNumberOfGuestsSelector,
} from "../../containers/App/selectors";
import { occupantRestrictionSelector as appOccupantRestrictionSelector } from "../../containers/App/selectors";

export const getModelSelector = state => state[name];
export const propsSelector = (_, props) => props;

export const loadingSelector = createSelector(
  getModelSelector,
  model => model && model.get("loading")
);

export const fullCalendarARILoadingSelector = createSelector(
  getModelSelector,
  model => model && model.get("fullCalendarARILoading")
);

export const dataWithExchangeSelector = createSelector(
  getModelSelector,
  propsSelector,
  currencySelector,
  currencyExchangeSelector,
  (model, props, currency, exchange) => {
    if (
      !model ||
      !model.get("data") ||
      !model.getIn(["data", props.propertyTicker, props.inventoryTicker || props.propertyTicker])
    ) {
      return;
    }
    if (model && currency !== exchange.get("currencyBase")) {
      let lModel = {
        ...model.getIn([
          "data",
          props.propertyTicker,
          props.inventoryTicker || props.propertyTicker,
        ]),
      };
      lModel = Object.keys(lModel).reduce(
        (accum, curr) => ({
          ...accum,
          [curr]: lModel[curr] * exchange.getIn(["prices", currency]),
        }),
        {}
      );
      return lModel;
    }

    return (
      model &&
      model.getIn(["data", props.propertyTicker, props.inventoryTicker || props.propertyTicker])
    );
  }
);

export const calendarARISelector = createSelector(
  getModelSelector,
  propsSelector,
  (model, props) => {
    if (
      !model ||
      !model.get("calendarARI") ||
      !model.getIn([
        "calendarARI",
        props.propertyTicker,
        props.inventoryTicker || props.propertyTicker,
      ])
    ) {
      return;
    }
    const calendarARI = model.getIn([
      "calendarARI",
      props.propertyTicker,
      props.inventoryTicker || props.propertyTicker,
    ]);
    const calendarARIMap = calendarARI.reduce((accumulator, dayValues) => {
      accumulator[getCalendarKey(dayValues.date)] = dayValues;
      return accumulator;
    }, {});
    return Object.keys(calendarARIMap).length > 0 ? calendarARIMap : null;
  }
);

export const propertyTickerSelector = createSelector(
  propsSelector,
  props => props && props.propertyTicker
);

export const inventoryTickerSelector = createSelector(
  propsSelector,
  props => props && props.inventoryTicker
);
export const fullARIForSelectedCalendarDatesSelector = createSelector(
  getModelSelector,
  model => model && model.get("fullARIForSelectedCalendarDates")
);

export const errorSelector = createSelector(getModelSelector, model => model && model.get("error"));

export const loadedSelector = createSelector(
  getModelSelector,
  model => model && model.get("loaded")
);

export const startDateSelector = createSelector(
  getModelSelector,
  propertyTickerSelector,
  (model, propertyTicker) => model && model.get("from") && model.get("from").get(propertyTicker)
);

export const endDateSelector = createSelector(
  getModelSelector,
  propertyTickerSelector,
  (model, propertyTicker) => model && model.get("to") && model.get("to").get(propertyTicker)
);

export const numberOfNightsSelector = createSelector(
  startDateSelector,
  endDateSelector,
  (startDate, endDate) => startDate && endDate && dateDiffInDays(startDate, endDate)
);

export const numberOfGuestsSelector = appNumberOfGuestsSelector;

export const occupantRestrictionSelector = appOccupantRestrictionSelector;

export const mainAriValueSelector = createSelector(
  propertyTickerSelector,
  fullARIForSelectedCalendarDatesSelector,
  numberOfNightsSelector,
  inventoryTickerSelector,
  (propertyTicker, fullARIForSelectedCalendarDates, numberOfNights, inventoryTicker) => {
    let totalRate = null;
    let rackRate = null;
    let averageRackRate = null;
    let averageRate = null;
    let discountPercentage = null;
    let statusDetail = null;
    let currency;

    if (
      propertyTicker &&
      fullARIForSelectedCalendarDates &&
      fullARIForSelectedCalendarDates.get(propertyTicker)
    ) {
      const hotelAriValue = fullARIForSelectedCalendarDates
        .get(propertyTicker)
        .get("arivalues")
        .get(propertyTicker);

      let bookableTicker = hotelAriValue.get("cheapestBookable");
      // When the calendar if for the entire HOTEL (inventoryTicker === null),
      // we get the aggregated status of the hotel
      statusDetail = hotelAriValue.get("lastStatus");
      if (inventoryTicker) {
        bookableTicker = inventoryTicker;
        currency = fullARIForSelectedCalendarDates
          .get(propertyTicker)
          .get("arivalues")
          .get(propertyTicker)
          .get("currency");
      }
      if (bookableTicker) {
        const bookableAriValue = fullARIForSelectedCalendarDates
          .get(propertyTicker)
          .get("arivalues")
          .get(bookableTicker);
        if (bookableAriValue) {
          /* TODO: USE CURRENCY CONVERSION */
          totalRate = bookableAriValue.get("totalRate");
          rackRate = bookableAriValue.get("rackRate");
          if (!rackRate) {
            rackRate = bookableAriValue.get("originalRate");
          }
          if (rackRate <= totalRate) {
            rackRate = null;
          }
          if (rackRate) {
            averageRackRate = rackRate / numberOfNights;
          }
          averageRate = bookableAriValue.get("averageRate");
          discountPercentage = bookableAriValue.get("discountPercentage");
          // If we require the details of only ONE inventory line (inventoryTicker != null),
          // we get the status of that particular line instead of the general hotel status
          if (inventoryTicker) {
            statusDetail = bookableAriValue.get("lastStatus");
          }
        }
      }
    }
    return {
      totalRate,
      averageRate,
      discountPercentage,
      statusDetail: statusDetail,
      averageRackRate,
      rackRate,
      currency,
    };
  }
);

export const mainAriValueWithExchangeSelector = createSelector(
  mainAriValueSelector,
  currencySelector,
  currencyExchangeSelector,
  (mainAriValue, currency, exchange) => {
    const exchangeRate = exchange && exchange.getIn(["prices", currency]);
    if (currency && exchangeRate) {
      return {
        averageRackRate: mainAriValue.averageRackRate * exchangeRate,
        averageRate: mainAriValue.averageRate * exchangeRate,
        discountPercentage: mainAriValue.discountPercentage,
        rackRate: mainAriValue.rackRate * exchangeRate,
        statusDetail: mainAriValue.statusDetail,
        totalRate: mainAriValue.totalRate * exchangeRate,
      };
    } else {
      return mainAriValue;
    }
  }
);

export const inventoryDetailsSelector = createSelector(
  propertyTickerSelector,
  fullARIForSelectedCalendarDatesSelector,
  inventoryTickerSelector,
  (propertyTicker, fullARIForSelectedCalendarDates, inventoryTicker) => {
    if (propertyTicker && inventoryTicker && fullARIForSelectedCalendarDates) {
      const inventory = fullARIForSelectedCalendarDates
        .get(propertyTicker)
        .get("inventories")
        .get(inventoryTicker);
      if (inventory) {
        const accommoddationName = inventory.get("accommodation");
        const name = inventory.get("name").split(", ");
        const defaultPrimaryText = name[0];
        const mealPlanName = name[1];
        const conditionName = name[2];
        return {
          accommoddationName,
          defaultPrimaryText,
          mealPlanName,
          conditionName,
        };
      }
    }
  }
);
